import * as React from 'react';
import * as _ from 'lodash-es';
import classNames from 'classnames';

const styles = require('./styles.pcss');

import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import CircularProgress from '@mui/material/CircularProgress';

import { ReduxState } from '../../reducers/types';

import {
  login,
  ssoLogin,
  resetNoAccess,
  setStateToSso,
} from '../../actions/User/Login';

type Props = any;

type State = {
  email: string;
  password: string;
  errorEmail: boolean;
  errorPassword: boolean;
  waitingResponse: boolean;
  showPassword: boolean;
  loading: boolean;
  hasNavigated: boolean;
};

class Login extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errorEmail: false,
      errorPassword: false,
      waitingResponse: false,
      showPassword: false,
      loading: false,
      hasNavigated: false,
    };

    if (
      _.get(
        this.props.userLogin,
        'isLoggedIn',
        false && !this.state.hasNavigated,
      ) === true
    ) {
      if (_.get(this.props.userLogin, 'forceResetPassword', false) === true) {
        this.setState({ hasNavigated: true });
        this.handleNavigation('/change-password');
      } else {
        this.setState({ hasNavigated: true });
        this.handleNavigation('/lookup');
      }
    }
  }

  handleNavigation = (path: string) => {
    this.props.navigate(path);
  };
  componentDidMount() {
    this.props.resetNoAccess();
  }
  componentWillReceiveProps(nextProps: any) {
    if (this.state.loading) {
      this.setState({
        loading: false,
      });
    }

    if (
      _.get(nextProps.userLogin, 'isLoggedIn', false) === true &&
      !this.state.hasNavigated
    ) {
      if (_.get(nextProps.userLogin, 'forceResetPassword', false) === true) {
        this.setState({ hasNavigated: true });
        this.handleNavigation('/change-password');
      } else {
        this.setState({ hasNavigated: true });
        this.handleNavigation('/lookup');
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    // Redirect to SSO entry point if needed
    const prevEntryPoint = _.get(prevProps.userLogin, 'ssoEntryPoint', null);
    const currEntryPoint = _.get(this.props.userLogin, 'ssoEntryPoint', null);
    const shouldRedirect = _.get(this.props.userLogin, 'shouldRedirectToEntryPoint', false);

    if (
      shouldRedirect &&
      currEntryPoint &&
      currEntryPoint !== prevEntryPoint
    ) {
      window.open(currEntryPoint, '_self');
    }
  }

  handleChangeEmail = (event: any) => {
    this.setState({
      email: event.target.value,
      errorEmail: false,
    });
  };

  handleChangePassword = (event: any) => {
    this.setState({
      password: event.target.value,
      errorPassword: false,
    });
  };

  handleSubmit = () => {
    if (_.get(this.props.userLogin, 'loginWithPassword', false)) {
      this.regularLogin();
    } else {
      this.ssoLogin();
    }
  };

  regularLogin = () => {
    if (this.state.loading === true) {
      return;
    }

    let errorEmail = false;
    let errorPassword = false;

    if (this.state.email.trim() == '') {
      errorEmail = true;
    }
    if (this.state.password.trim() == '') {
      errorPassword = true;
    }

    this.setState({
      errorEmail: errorEmail,
      errorPassword: errorPassword,
    });

    if (errorPassword == false && errorEmail == false) {
      this.setState({
        loading: true,
      });

      this.props.login(this.state.email, this.state.password);
    }
  };

  ssoLogin = () => {
    if (this.state.loading === true) {
      return;
    }

    let errorEmail = false;
    if (this.state.email.trim() == '') {
      errorEmail = true;
    }

    this.setState({
      errorEmail: errorEmail,
    });

    if (errorEmail == false) {
      this.setState({
        loading: true,
      });

      this.props.ssoLogin(this.state.email);
    }
  };

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  handleClickLoginWithSSO = () => {
    this.props.setStateToSso();
  };

  /**
   * Handle form submit on enter
   */
  onKeyUp = (e: any) => {
    if (e.keyCode === 13) {
      this.handleSubmit();
    }
  };

  render() {
    return (
      <div className={styles.pageLogin}>
        <Card className={styles.card}>
          <CardContent className={styles.cardContent}>
            <h1 className={styles.title}>BlackBox</h1>
            <TextField
              fullWidth
              id="email"
              className={styles.textField}
              label="Email"
              variant="outlined"
              margin="normal"
              value={this.state.email}
              onChange={this.handleChangeEmail}
              error={this.state.errorEmail}
              onKeyUp={this.onKeyUp}
            />
            {_.get(this.props.userLogin, 'loginWithPassword', false) ===
              true && (
              <TextField
                fullWidth
                id="password"
                className={styles.textField}
                label="Password"
                type={this.state.showPassword ? 'text' : 'password'}
                margin="normal"
                variant="outlined"
                autoComplete="current-password"
                value={this.state.password}
                onChange={this.handleChangePassword}
                error={this.state.errorPassword}
                onKeyUp={this.onKeyUp}
                InputProps={{
                  endAdornment: this.state.password !== '' && (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        size="large">
                        {this.state.showPassword ? (
                          <Visibility
                            className={classNames(
                              styles.icon,
                              styles.eyeVisible,
                            )}
                          />
                        ) : (
                          <Visibility className={styles.icon} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}

            <Button
              id="button-login"
              fullWidth
              className={styles.button}
              variant="contained"
              color="primary"
              disabled={this.state.loading}
              onClick={this.handleSubmit}
              disableRipple={true}
            >
              Log In
            </Button>

            {_.get(this.props.userLogin, 'loginWithPassword', false) ===
              true && (
              <a
                className={styles.link}
                onClick={this.handleClickLoginWithSSO}
              >
                Login with SSO
              </a>
            )}

            {this.state.loading && (
              <CircularProgress
                size={24}
                style={{
                  position: 'absolute',
                  left: '50%',
                  marginTop: 28,
                  marginLeft: -12,
                }}
              />
            )}
          </CardContent>
        </Card>
      </div>
    );
  }
}

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {
    userLogin: state.userLogin,
  };
}

// Wire up redux dispatch functions
function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      login,
      ssoLogin,
      resetNoAccess,
      setStateToSso,
    },
    dispatch,
  );
}

// Connect it to Redux
export default connectWithRouter(mapStateToProps, mapDispatchToProps)(Login);
